<template>
    <div>
        <b-card no-body class="page-card">
            <b-card-header class="mx-3 px-0">
                <i class="fa fa-align-justify"></i> {{ trans.title }}
            </b-card-header>
            <b-card-body class="text-center">
                <p>
                    <b>{{ trans.question_label }}</b>
                </p>
                <br>
                <!--<div class="input-group">
                    <input placeholder="Vyhľadať..." class="form-control py-0"> 
                    <span class="btn-group input-group-btn">
                        <button type="button" class="btn btn-primary">
                            <i class="fa fa-search"></i>
                        </button>
                    </span>
                </div>-->
                <p class="mt-3">
                    {{ trans.contact_us_label }}:
                </p>
                <div class="btn-group">
                    <a :href="'mailto:podpora@dochadzka.app?subject='+trans.emailSubject" class="btn btn-light"><i class="fal fa-at"></i> Email</a>
                    <a href="https://webnotion.atlassian.net/servicedesk/" target="_blank" class="btn btn-danger"><i class="fal fa-globe"></i> Service desk</a>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'support',

        props: {
            'trans': {
                type: Object
            }
        }
        
    }
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/dashboard/widgets/Support.vue